import { useEffect, useState } from "react";
import "./hallMainInformation.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import WeddinghallPartnerSummary from "@src/pages/weddingHall/_component/detail/WeddinghallPartnerSummary";
import HallBenefits from "./HallBenefits";
import { Badge } from "../home/HomeHallCard";
import { addComma, HOSTNAME, isExternalUrl } from "@src/utils";
import { IPartnerBenefit } from "@src/api/partner/partner";
import { getActiveEventsByHall, type ActiveEventByHallItem } from "@src/api/weddingHall/event";

type pageType = "partner" | "weddinghall";
export default function HallMainInformation(props: {
  type: pageType;
  partnerName: string;
  partnerUuid?: string;
  summaries: {
    iconUrl: string;
    textArr: string[];
  }[];
  benefits: IPartnerBenefit[];
  comparisonClassNames?: {
    bizName?: string;
    specialFeatures?: string;
    benefits?: string;
  };
  productBtn?: { name: string; func: (idx: number) => void } | null; // 잔여타임 이동 버튼
  price?: { discountRate: number; minPrice: number; totalAmount: number }; //웨딩홀 가격 정보
  availableContract?: boolean;
  isWeeklyReservationActive?: boolean;
}) {
  const [activeEvents, setActiveEvents] = useState<ActiveEventByHallItem[]>([]);

  useEffect(() => {
    if (!props.partnerUuid || props.type !== "weddinghall") return;
    getActiveEventsByHall(props.partnerUuid)
      .then(setActiveEvents)
      .catch(() => setActiveEvents([]));
  }, [props.partnerUuid, props.type]);
  return (
    <div className="hall-main-information-wrap">
      <div className="badge-wrap">
        {props.availableContract && <Badge icon="Thunder" iconColor="#F53F29" />}
        {props.benefits.map((benefit, idx) => {
          if (benefit.tag === "할인") return null;
          if (benefit.tag) {
            return <Badge text={benefit.tag} key={`hall-list-badge-${benefit.tag}-${idx}`} />;
          }
        })}
        {props.isWeeklyReservationActive && <Badge text="주단위예약" />}
      </div>
      <h2 className={`hall-name ${props.comparisonClassNames?.bizName}`}>{props.partnerName}</h2>

      {props.type === "weddinghall" && !!props.price && (
        <div className={`hall-price`} style={{ alignItems: "center" }}>
          {" "}
          {/** 가격 정책 정립 전까지 최저가만 표시, 스타일 추후 삭제 */}
          <div>
            {/* {props?.price?.totalAmount !== props?.price?.minPrice && <p className="total-price">{addComma(props?.price?.totalAmount)}원 ~</p>} */}
            <p className="discount bold">
              {/* <span>{props?.price?.discountRate > 0 && `${props?.price?.discountRate}% `}</span> */}
              [정가] {props.price.totalAmount ? addComma(props.price.totalAmount) : "-"}원~
            </p>
            <p className="description">*위 금액은 대관료 + 식대 등을 합한 총 금액입니다.</p>
          </div>
          {props.productBtn !== null && (
            <button
              className="btn btn-medium btn-outline-gray200"
              onClick={() => props?.productBtn?.func(2)}
            >
              {props?.productBtn?.name}
            </button>
          )}
        </div>
      )}
      <div className={`${props.comparisonClassNames?.specialFeatures}`}>
        <WeddinghallPartnerSummary summaries={props.summaries} />
      </div>
      <div className={`${props.comparisonClassNames?.benefits} benefits-wrap`}>
        <h2 className="title">혜택</h2>
        <HallBenefits benefits={props.benefits} activeEvents={activeEvents} />
        <WeddinghallEventBanner banners={props.benefits} />
      </div>
    </div>
  );
}

const WeddinghallEventBanner = ({ banners }) => {
  const eventBanner = banners.filter(
    (banner) => banner.bannerUrl !== null && banner.bannerUrl !== "",
  );

  // 이벤트 배너가 없으면 렌더링하지 않음
  if (!eventBanner || eventBanner.length === 0) {
    return null;
  }

  const sliderSettings = {
    slidesPerView: 1, // 한 슬라이드에 하나의 이미지만 표시
    speed: 500,
    spaceBetween: 0, // 슬라이드 간 간격 제거
    autoHeight: false,
    autoplay: {
      delay: 3000, // 3초마다 자동 슬라이드
      disableOnInteraction: false, // 사용자 상호작용 후에도 자동 슬라이드 계속
    },
    modules: [Autoplay], //[Pagination],
    loop: eventBanner.length > 1, // 배너가 1개 초과일 때만 loop 활성화
    centeredSlides: false, // 중앙 배치 비활성화
    touchRatio: 1, // 터치 민감도 기본값 설정
    longSwipesRatio: 0.5, // 긴 스와이프 임계값 설정
    longSwipesMs: 300, // 긴 스와이프 시간 임계값
    shortSwipes: true, // 짧은 스와이프 허용
    followFinger: true, // 손가락 따라 움직임 허용
    preventClicks: true, // 스와이프 중 클릭 방지
    preventClicksPropagation: true, // 스와이프 중 클릭 이벤트 전파 방지
    slideToClickedSlide: false, // 클릭한 슬라이드로 이동 비활성화
  };

  return (
    <div className="event-banner-wrap">
      <div className="event-banner-container">
        <Swiper {...sliderSettings}>
          {eventBanner?.map((banner, index) => (
            <SwiperSlide key={`event-banner-${index}`}>
              <div
                className="event-banner-slide"
                onClick={() => {
                  if (banner.bannerLink) {
                    window.location.href = isExternalUrl(banner.bannerLink);
                  }
                }}
              >
                <img src={banner.bannerUrl} alt={banner.title} />
              </div>
              {eventBanner.length > 1 && (
                <div className="event-banner-pagination">
                  {index + 1} / {eventBanner.length}
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
